import type { IconSvgObject } from './types';

const SpaceIcon: IconSvgObject = [
  ["path", { d: "M20.9922 10C20.9922 10.93 20.9922 11.395 20.89 11.7765C20.6126 12.8117 19.8039 13.6204 18.7686 13.8978C18.3871 14 17.9222 14 16.9922 14H6.99219C6.06222 14 5.59723 14 5.21573 13.8978C4.18045 13.6204 3.37181 12.8117 3.09441 11.7765C2.99219 11.395 2.99219 10.93 2.99219 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default SpaceIcon;
